import React, { useEffect, useState, useImperativeHandle, forwardRef } from "react"
import { Tabs, Form, Row, Col, Select, Modal } from 'antd';
import Input from '../../../ui/Input';
import TextArea from '../../../ui/TextArea';
import { getOTACodes } from '../../../../services/common'
// import { LocalPersistence } from "../../../../factories";
// import { addSecurity } from '../../../../services/amenityservice';
import '../../Table/TabpanelDetail.css'
const { TabPane } = Tabs;
const { Option } = Select;
let newTabIndex = 10;
let newTabIndexArr: any = [];
let errHandle = false;
const AddAccessibilityAndSecurity = forwardRef((props: any,ref:any) => {
    const [form]: any = Form.useForm()
    const [mrfData, setMrfData] = useState([])
    const [typeList, setTypeList] = useState<Array<any>>([]);
    const [addId,setAddId] = useState(0);
    const [requiredFlag,setRequiredFlag] = useState(true)

    const initData =  [
        {
            'closable':false,
            'id':addId,
            "type": "",
            
            "typedetail": "",
            
            "description": "",

        }
    ]
    const initialPanes: any = initData ? initData : []
    const [panes, setPanels] = useState(initialPanes)
   
    
    useEffect(() => {
        newTabIndex = panes.length > 0 ? Number(panes.length) : 0;
        getMRFdata()
        getTypeList()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])
    const onChangeItem = ()=>{
        setRequiredFlag(true)
      }
    const getTypeList = async () => {
        // setAddLoading(true)
        let res = await getOTACodes('REC', '')
        // setAddLoading(false)
        if (res && res.otacodes && res.otacodes.length != 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setTypeList(res.otacodes)
        } else {
            setTypeList([])
        }
    }
    const getMRFdata = async () => {
        let res = await getOTACodes('CUR', '')
        let rest = res?.otacodes || []
        setMrfData(rest)
        console.log(mrfData)
    }
    // const saveClick = async () => {
    //     const get_session = new LocalPersistence('session')
    //     const session: any = await get_session.getSessionPersistence()

    //     form.validateFields().then(async (value: any) => {

    //         let parmars = {
                
    //                 "supplier":session.supplier,
    //                 "propertyId":session.propertyId,
    //                 "property":{
    //                    "amenityservice":[
    //                       {
    //                          "security":[
    //                             value
    //                          ]
    //                       }
    //                    ]
    //                 }
                 
    //         }
    //         let res = await addSecurity(parmars)
    //         if(res.result.success){
    //             props.setEditToDetail()
    //         }
    //     })
    // }

    
    // props.currentLine.capacity?props.currentLine.capacity: []

    const [activeKey, setActiveKey] = useState(initialPanes.length != 0 ? initialPanes[0].capacityid : 0)
    

    const onChange = (activeKey: any) => {
        setActiveKey(activeKey)
    };

    const onEdit = (targetKey: any, action: any) => {
        if (action == 'add') {
            add()
        } else if (action == 'remove') {
            remove(targetKey)
        }
    };

    const add = () => {
        newTabIndex = panes.length > 0 ? Number(panes.length) : 0;
        const newKey = ++newTabIndex;
        newTabIndexArr.push(newKey)
        let id = addId
        id++
        const newPanes = [...panes,{id:id, closable:true,description:"",type:"",typedetail:"",detailid:newKey}];
        newPanes[0].closable = true
        setPanels(newPanes)
        setAddId(id)
        setActiveKey(JSON.stringify(newKey-1))
        setRequiredFlag(true)
        // onChange(JSON.stringify(newKey-1))
    };
    const ModalHead = () => {
        return (
            <div style={{
                position: 'absolute',
                left: 0,
                top: 0,
                height: '50px',
                lineHeight: '50px',
                textIndent: '10px',
                borderBottom: '1px solid #ccc',
                color: '#fff',
                background: '#06789D',
                fontSize: 18,
                width: '100%'
            }}>Confirm</div>
        )
    }
    const remove = (targetKey: any) => {
        panes.filter((item: any,i:any) => Number(targetKey) == i)
        let daleteTitle = ""
        panes.forEach((pane: any, i: any) => {
            if (i == targetKey) {
                daleteTitle = pane.id;
            }
        });
        Modal.confirm({
            title: <ModalHead />,
            centered: true,
            icon: '',
            content: `Are you sure you want to delete Detail ${daleteTitle+1}?`,
            cancelText: 'Cancel',
            okText: 'Delete',
            onOk() {
                let newActiveKey = targetKey;
                let lastIndex: any;
                panes.forEach((pane: any, i: any) => {
                    if (i == targetKey) {
                        lastIndex = i - 1;
                    }
                });
                const newPanes = panes.filter((pane: any,i:any) => i !== Number(targetKey));
                if (newPanes.length && newActiveKey === targetKey) {
                    if (lastIndex >= 0) {
                        newActiveKey = JSON.stringify(newPanes.length-1);
                        newTabIndex--
                    } else {
                        newActiveKey = "0";
                    }
                }
                if (newPanes.length === 1) {
                    newActiveKey = '0'
                    newPanes[0].closable = false
                  }
                  if(newPanes.length === 0){
                    const newDetails = [{ 
                        closable:true,
                        "accsecurity": "",
                        "type": "",
                        "quantity": "",
                        "typedetail": "",
                        "uom": "",
                        "charge": "",
                        "currency": "",
                        "description": "",
                        'id':panes[targetKey].id
                    }]
                    setPanels(newDetails)
                    setActiveKey(newActiveKey)
                    form.resetFields()
                    setRequiredFlag(false)
                    return;
                }
                setPanels(newPanes)
                setActiveKey(newActiveKey)
            },
            onCancel() {

            },
        });
    };
    
    useImperativeHandle(ref, () => ({
        form: form,
        restoreErr: () => { errHandle = false }
    }));
    useEffect(() => {
        if (errHandle) {
            props.validateFieldsError();
          } else {
            errHandle = true;
          }
      }, 
      // eslint-disable-next-line react-hooks/exhaustive-deps 
      [panes])
    return (
        <>
                <div className='addAccessbilityItem' style={{ background: '#fff'}}>
                    <Form
                        layout="vertical"
                        form={form}
                        name="basic"
                        initialValues={panes}
                        onValuesChange={(changedFields, allFields) => {
                            props.validateFieldsError();
                          }}
                    >
                        <Tabs
                            type="editable-card"
                            onChange={onChange}
                            activeKey={activeKey}
                            onEdit={onEdit}
                            className = 'addAccessbilitytTabs'
                            style={{paddingLeft:'16px'}}
                        >
                            {panes.map((pane: any, i: number) => (
                                <TabPane className='addAccessbilitytTabpane' tab={'Detail ' + (pane.id + 1)} key={i} forceRender={true}>
                                    <Row gutter={24}>
                                        <Col span={6}>
                                            <Form.Item
                                                label="Type"
                                                name={[pane.id, 'type']}
                                            >
                                                <Select allowClear onChange={onChangeItem} showSearch>
                                                    {typeList.length > 0 && typeList.map((item: any, index: any) => {
                                                        return (
                                                            <Option key={index} value={item.codeName}>{item.codeName}</Option>
                                                        )
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                label="Type Detail"
                                                name={[pane.id, 'typedetail']}
                                                rules={[{ max: 128, message: 'You have reached the max character length of 128' }]}
                                            >
                                                <Input maxLength={128} onChange={onChangeItem} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={6}></Col>
                                        <Col  span={18}>
                                            <Form.Item
                                                label="Description"
                                                name={[pane.id, 'description']}
                                                rules={[{ max: 300, message: 'You have reached the max character length of 300' }]}
                                            >
                                                <TextArea maxLength={300} onChange={onChangeItem} rows={3} />
                                            </Form.Item>
                                        </Col>
                                       
                                    </Row>
                                    
                                </TabPane>
                            ))}
                        </Tabs>
                    </Form>
                </div>
            {/* <Card>
                <div style={{ height: '50px', display: 'flex', justifyContent: 'flex-end', padding: '8px', marginTop: '10px' }}>
                    <p>
                        <Button type='primary' style={{ background: '#fff', width: 90, borderRadius: 3, color: '#004771', borderColor: '#ccc' }} onClick={() => { props.cancelAndSave() }}>Cancel</Button>
                        <Button onClick={saveClick} type='primary' style={{ background: '#004771', width: 90, borderRadius: 3, color: '#fff', borderColor: '#004771', marginLeft: 10 }}>Save</Button>
                    </p>
                </div>
            </Card> */}
        </>
    )
})

export default AddAccessibilityAndSecurity

